import { isAxiosError } from 'axios';
import dayjs from 'dayjs';

import { useCallback, useRef } from 'react';

import type { ContractRequest } from 'state/__generated__/tadaahAPI';

import { useApiOrganisationContractsRequestCreateCreate } from 'state/__generated__/tadaahAPI';

type UseRequestContractType = {
  initialValues: ContractRequest;
  error: string | null;
  isLoading: boolean;
  isSuccess: boolean;
  requestContracts: (values: ContractRequest) => Promise<void>;
};

const useRequestContracts = (): UseRequestContractType => {
  const initialValues: ContractRequest = {
    from_date: dayjs().format('YYYY-MM-DD'),
    to_date: dayjs().format('YYYY-MM-DD'),
  };
  const { mutateAsync, error, isLoading, isSuccess } =
    useApiOrganisationContractsRequestCreateCreate<Error>({
      mutation: {
        mutationKey: 'freelancer-confirm-reset-password',
      },
    });

  const customError = useRef<string>('');

  const requestContracts = useCallback(
    async (values: ContractRequest) => {
      try {
        await mutateAsync({ data: values });
        customError.current = '';
      } catch (er) {
        if (isAxiosError(er) && er.response?.status === 429)
          customError.current = er.response?.data?.errors?.[0];
        else customError.current = 'Something went wrong!';
      }
    },
    [mutateAsync],
  );

  return {
    error: customError.current || error?.message || null,
    initialValues,
    isLoading,
    isSuccess,
    requestContracts,
  };
};

export default useRequestContracts;
